import { render, staticRenderFns } from "./ModalDocumentosBemTerceiro.vue?vue&type=template&id=78e040e8&scoped=true"
import script from "./ModalDocumentosBemTerceiro.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosBemTerceiro.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentosBemTerceiro.vue?vue&type=style&index=0&id=78e040e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e040e8",
  null
  
)

export default component.exports